// app/javascript/controllers/modal_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  dismiss() {
    // Simple approach: clear the container's innerHTML
    if (this.hasContainerTarget) {
      this.containerTarget.innerHTML = ""
    }
    
    // Alternative: if the modal is a proper <dialog> element
    const dialog = this.element.querySelector('dialog')
    if (dialog) {
      dialog.close()
      // Optionally remove after animation completes
      dialog.addEventListener('transitionend', () => {
        dialog.remove()
      }, { once: true })
    }
  }
}